import { render, staticRenderFns } from "./ProductDescription.vue?vue&type=template&id=1e690cde"
import script from "./ProductDescription.vue?vue&type=script&lang=js"
export * from "./ProductDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports